import { gql, TypedDocumentNode } from "@apollo/client";

import {
  EditUserMutation,
  EditUserMutationVariables,
} from "./EditUser.generated";

const EDIT_USER: TypedDocumentNode<
  EditUserMutation,
  EditUserMutationVariables
> = gql`
  mutation editUser(
    $email: String
    $firstName: String
    $lastName: String
    $isOnboardingComplete: Boolean
    $autoExportEmail: String
    $emailExpiryDays: Int
    $shouldEmbedEmailExports: Boolean
    $shouldUseAutoSoaps: Boolean
    $roleId: Int
    $onboardingClinic: String
    $onboardingCorporateGroup: String
    $onboardingReferralSource: String
    $onboardingMilestones: GenericScalar
    $pimsProvider: String
  ) {
    editUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      isOnboardingComplete: $isOnboardingComplete
      autoExportEmail: $autoExportEmail
      emailExpiryDays: $emailExpiryDays
      shouldEmbedEmailExports: $shouldEmbedEmailExports
      shouldUseAutoSoaps: $shouldUseAutoSoaps
      roleId: $roleId
      onboardingClinic: $onboardingClinic
      onboardingCorporateGroup: $onboardingCorporateGroup
      onboardingReferralSource: $onboardingReferralSource
      onboardingMilestones: $onboardingMilestones
      pimsProvider: $pimsProvider
    ) {
      user {
        uuid
        email
        firstName
        lastName
        isOnboardingComplete
        autoExportEmail
        emailExpiryDays
        shouldEmbedEmailExports
        shouldUseAutoSoaps
        roleId
        onboardingClinic
        onboardingCorporateGroup
        onboardingReferralSource
        onboardingMilestones
        pimsProvider
      }
    }
  }
`;

export default EDIT_USER;
